import FormsNewProduct from "@/views/forms/NewProduct";
import FormsImmediateProduct from "@/views/forms/ImmediateProduct";
import FormsRequestPhoto from "@/views/forms/RequestPhoto";
import FormsOfflineAssortment from "@/views/forms/RequestOfflineAssortment";
import FormsReportImperfection from "@/views/forms/ReportImperfection";
import FormsReportImperfectionInceptionOosterwolde from "@/views/forms/ReportImperfectionInceptionOosterwolde";
import FormsReportImperfectionInceptionApeldoorn from "@/views/forms/ReportImperfectionInceptionApeldoorn";
import FormsReportImperfectionInceptionAlkmaar from "@/views/forms/ReportImperfectionInceptionAlkmaar";
import FormsRequestNewDepartment from "@/views/forms/RequestNewDepartment";
import FormsRequestStopDepartment from "@/views/forms/RequestStopDepartment";

export default [
  {
    path: "forms/requestNewProduct",
    name: "requestNewProduct",
    component: FormsNewProduct,
    meta: {
      title: "Product aanvragen"
    }
  },
  {
    path: "forms/requestImmediateProduct",
    name: "requestImmediateProduct",
    component: FormsImmediateProduct,
    meta: {
      title: "Aanvraagformulier rollen"
    },
    beforeEnter: (to: any, from: any, next: any) => {
      if (
        (process.env.VUE_APP_LOCATION === "oosterwolde" &&
          process.env.VUE_APP_ENV === "production") ||
        (process.env.VUE_APP_LOCATION === "apeldoorn" &&
          process.env.VUE_APP_ENV === "production") ||
        process.env.VUE_APP_ENV !== "production"
      ) {
        next();
      } else {
        // Redirect to home
        next("/");
      }
    }
  },
  {
    path: "forms/requestOfflineAssortment",
    name: "requestOfflineAssortment",
    component: FormsOfflineAssortment,
    meta: {
      title: "Kuur medicatiesets"
    },
    beforeEnter: (to: any, from: any, next: any) => {
      if (process.env.VUE_APP_LOCATION !== "oosterwolde") {
        next();
      } else {
        // Redirect to home
        next("/");
      }
    }
  },
  {
    path: "forms/requestPhoto",
    name: "requestPhoto",
    component: FormsRequestPhoto,
    meta: {
      title: "Foto aanvragen"
    }
  },
  {
    path: "forms/requestNewDepartment",
    name: "requestNewDepartment",
    component: FormsRequestNewDepartment,
    meta: {
      title: "Aanmeldformulier nieuwe afdeling"
    }
  },
  {
    path: "forms/requestStopDepartment",
    name: "requestStopDepartment",
    component: FormsRequestStopDepartment,
    meta: {
      title: "Afdeling stopzetten / laten vervallen"
    }
  },
  {
    path: "forms/reportImperfection",
    name: "reportImperfection",
    component: FormsReportImperfection,
    meta: {
      title: "Melding onvolkomenheden"
    },
    beforeEnter: (to: any, from: any, next: any) => {
      if (
        process.env.VUE_APP_ENV === "test" ||
        process.env.VUE_APP_ENV === "acceptance"
      ) {
        next();
      } else {
        // Redirect to home
        next("/");
      }
    }
  },
  {
    path: "forms/reportImperfectionInceptionOosterwolde",
    name: "reportImperfectionInceptionOosterwolde",
    component: FormsReportImperfectionInceptionOosterwolde,
    meta: {
      title: "Melding onvolkomenheden inception"
    },
    beforeEnter: (to: any, from: any, next: any) => {
      if (
        (process.env.VUE_APP_LOCATION === "oosterwolde" &&
          process.env.VUE_APP_ENV === "production") ||
        process.env.VUE_APP_ENV === "test" ||
        process.env.VUE_APP_ENV === "acceptance"
      ) {
        next();
      } else {
        // Redirect to home
        next("/");
      }
    }
  },
  {
    path: "forms/reportImperfectionInceptionApeldoorn",
    name: "reportImperfectionInceptionApeldoorn",
    component: FormsReportImperfectionInceptionApeldoorn,
    meta: {
      title: "Melding onvolkomenheden inception"
    },
    beforeEnter: (to: any, from: any, next: any) => {
      if (
        (process.env.VUE_APP_LOCATION === "apeldoorn" &&
          process.env.VUE_APP_ENV === "production") ||
        process.env.VUE_APP_ENV === "test" ||
        process.env.VUE_APP_ENV === "acceptance"
      ) {
        next();
      } else {
        // Redirect to home
        next("/");
      }
    }
  },
  {
    path: "forms/reportImperfectionInceptionAlkmaar",
    name: "reportImperfectionInceptionAlkmaar",
    component: FormsReportImperfectionInceptionAlkmaar,
    meta: {
      title: "Melding onvolkomenheden inception"
    },
    beforeEnter: (to: any, from: any, next: any) => {
      if (
        (process.env.VUE_APP_LOCATION === "alkmaar" &&
          process.env.VUE_APP_ENV === "production") ||
        process.env.VUE_APP_ENV === "test" ||
        process.env.VUE_APP_ENV === "acceptance"
      ) {
        next();
      } else {
        // Redirect to home
        next("/");
      }
    }
  }
];
